<template>
  <order-failure />
</template>

<script>
import OrderFailure from '@/components/order/OrderFailure'

export default {
  name: 'OrderFailurePage',
  components: { OrderFailure },
  metaInfo() {
    return {
      title: this.$t('meta.other.titleTmpl', {
        h1: this.$t('checkoutDeclined'),
      }),
      meta: [
        {
          name: 'robots',
          content: 'noindex, follow',
        },
        {
          name: 'description',
          content: this.$t('meta.other.descriptionTmpl', {
            h1: this.$t('checkoutDeclined'),
          }),
        },
      ],
    }
  },
  mounted() {
    this.$h.gtmDataLayerPush({
      ecomm_pagetype: 'other',
    })
  },
}
</script>
